<template>
  <div class="io-container container-fluid">
    <div
        class="row g-4 g-xl-5 io-eq"
        :class="`justify-content-${align}`"
    >
      <div
          v-if="useHeadline === '1' && ['start', 'end'].indexOf(align) >= 0"
          class="col-12 col-lg-5 col-xl-4"
          :class="align === 'end' ? 'order-lg-2' : 'order-lg-0'"
      >
        <IoHeadline
            size="h2"
            :text-align="headlineAlign"
        >
          <slot name="headline"></slot>
        </IoHeadline>
        <template v-if="hasTextContent">
          <BaseSpacer />
          <IoText
              :text-align="headlineAlign"
          >
            <slot name="text"></slot>
          </IoText>
        </template>
      </div>
      <div :class="colClass">
        <template v-if="useHeadline === '1' && align === 'center'">
          <IoHeadline
              size="h2"
              :text-align="headlineAlign"
          >
            <slot name="headline"></slot>
          </IoHeadline>
          <BaseSpacer />
          <template v-if="hasTextContent">
            <IoText
                :text-align="headlineAlign"
            >
              <slot name="text"></slot>
            </IoText>
            <BaseSpacer />
          </template>
        </template>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  computed,
  useSlots,
} from 'vue';

const props = defineProps({
  width: {
    type: String,
    default: 'default',
  },
  align: {
    type: String,
    default: 'none',
  },
  useHeadline: {
    type: String,
    default: '0',
  },
  headlineAlign: {
    type: String,
    default: 'start',
  },
});

const colClass = computed<string[]>(() => {
  const colClasses = ['col-12 order-lg-1'];

  if (props.useHeadline === '1' && ['start', 'end'].indexOf(props.align) >= 0) {
    colClasses.push('col-lg-7 col-xl-8');
  } else if (props.width === 'default') {
    colClasses.push('col-md-10 col-lg-9');
  } else if (props.width === 'small') {
    colClasses.push('col-md-9 col-lg-7');
  } else if (props.width === 'wide') {
    colClasses.push('col-md-10');
  }

  return colClasses;
});

const slots = useSlots();
const textContent = slots.text ? slots.text() : null;
const hasTextContent = computed(() => (
  textContent && textContent[0] ? `${textContent[0].children}`.trim().length > 0 : false
));
</script>
